
import { useState, useEffect } from 'react';

interface NavbarProps {
  scrolled: boolean;
}

export default function Navbar({ scrolled }: NavbarProps) {
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    // Lock body scroll when mobile menu is open
    if (mobileOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    // Cleanup in case component unmounts while menu is open
    return () => {
      document.body.style.overflow = '';
    };
  }, [mobileOpen]);

  const navLinks = [
    { label: 'How It Works', href: '#system' },
    { label: 'Features', href: '#features' },
    { label: 'Results', href: '#results' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? 'bg-white/90 backdrop-blur-xl shadow-lg shadow-black/5'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-6 lg:px-12">
        <div className="flex items-center justify-between h-20">
          <a href="#" className="flex items-center gap-3 cursor-pointer">
            <img
              src="https://public.readdy.ai/ai/img_res/fcffd992-bebb-41d6-acd9-7e64a0054896.png"
              alt="Brain Wash Logo"
              className="h-10 w-auto"
            />
          </a>

          <div className="hidden md:flex items-center gap-10">
            {navLinks.map((link) => (
              <a
                key={link.label}
                href={link.href}
                className={`text-sm font-medium tracking-wide transition-colors duration-300 cursor-pointer ${
                  scrolled
                    ? 'text-gray-700 hover:text-brand-pink'
                    : 'text-white/80 hover:text-white'
                }`}
              >
                {link.label}
              </a>
            ))}
            <a
              href="#cta"
              className="px-7 py-2.5 bg-gradient-to-r from-brand-orange via-brand-pink to-brand-violet text-white text-sm font-semibold rounded-full hover:shadow-lg hover:shadow-brand-pink/20 hover:scale-105 transition-all duration-300 whitespace-nowrap cursor-pointer animate-gradient-shift"
            >
              Begin Reset
            </a>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg cursor-pointer ${
              scrolled ? 'text-gray-900' : 'text-white'
            }`}
            aria-label="Toggle menu"
          >
            <i className={`ri-${mobileOpen ? 'close' : 'menu'}-line text-xl`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-white/95 backdrop-blur-xl border-t border-gray-100 px-6 py-8 space-y-4">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              onClick={() => setMobileOpen(false)}
              className="block text-base font-medium text-gray-800 py-2 cursor-pointer"
            >
              {link.label}
            </a>
          ))}
          <a
            href="#cta"
            onClick={() => setMobileOpen(false)}
            className="block w-full text-center px-7 py-3 bg-gradient-to-r from-brand-orange via-brand-pink to-brand-violet text-white text-sm font-semibold rounded-full cursor-pointer"
          >
            Begin Reset
          </a>
        </div>
      )}
    </nav>
  );
}
